export const GET_NOMINEE_DETAILS = "SET_BANK_DETAILS";
export const SET_NOMINEE_FOLIO = "SET_NOMINEE_FOLIO";
export const SET_NOMINEE_COUNT = "SET_NOMINEE_COUNT";
